import { animation } from "@universityofmaryland/web-styles-library";
const observeGridAnimations = () => {
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;
  if (prefersReducedMotion) return;
  const idGridFadeIn = `umd-animation-transition-fade-bottom`;
  const idOffsetAttr = `data-animation`;
  const animationOffset = `offset`;
  const applyStyles = () => {
    const body = document.body;
    const styleElement = document.createElement("style");
    const jssToCSS = (obj) => {
      let css = "";
      for (const [key, value] of Object.entries(obj)) {
        if (key === "className") continue;
        if (key.startsWith("@")) continue;
        if (typeof value === "object" && !Array.isArray(value)) {
          const nestedCSS = jssToCSS(value);
          css += `${key} { ${nestedCSS} } `;
        } else {
          const cssKey = key.replace(/([A-Z])/g, "-$1").toLowerCase();
          css += `${cssKey}: ${value}; `;
        }
      }
      return css;
    };
    styleElement.innerHTML = `
      @keyframes fade-in-from-bottom {
        from {
          opacity: 0;
          transform: translateY(50px);
        }

        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .${idGridFadeIn} {
        ${jssToCSS(animation.transition.fadeInFromBottom)}
      }
    `;
    body.appendChild(styleElement);
  };
  const setupInteractions = () => {
    const gridElements = Array.from(
      document.querySelectorAll(
        ".umd-animation-grid > *, .umd-grid-animation > *"
      )
    );
    const setAlignment = () => {
      let previousPosition = 0;
      gridElements.forEach((entry) => {
        const top = entry.getBoundingClientRect().top;
        if (previousPosition === top) {
          entry.setAttribute(idOffsetAttr, animationOffset);
        } else {
          previousPosition = top;
        }
      });
    };
    const gridAnimation = (entries, observer2) => {
      let delay = 0;
      entries.forEach((entry) => {
        const target = entry.target;
        const offset = 350;
        if (entry.isIntersecting) {
          if (target.getAttribute(idOffsetAttr) === animationOffset) {
            delay = delay + offset;
          } else {
            delay = 0;
          }
          target.style.animationDelay = `${delay}ms`;
          target.classList.add(idGridFadeIn);
          observer2.unobserve(target);
        }
      });
    };
    const observer = new IntersectionObserver(gridAnimation, {
      rootMargin: "0px",
      threshold: [0.35]
    });
    gridElements.forEach((element) => {
      observer.observe(element);
    });
    window.addEventListener("resize", () => {
      setAlignment();
    });
    setAlignment();
  };
  applyStyles();
  setupInteractions();
};
export {
  observeGridAnimations
};
//# sourceMappingURL=observeGridAnimations.js.map
